import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import ComparePanelPopup from './index';

export default function initComparePopup(mountEl) {
  ReactDOM.render(
    <Provider store={window.appState}>
      <ComparePanelPopup />
    </Provider>, mountEl
  );
}
